// extracted by mini-css-extract-plugin
export default {"container":"BND14u","label":"eBqbGj","tooltipContainer":"GJU0Gb","nameContainer":"GfeFhV","nameButton":"K8ELSV","name":"cA3tD3","tooltip":"ffnC8N","loader":"jAhXvq"};